// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3ZnAq","clinicsSelect":"TableHeading_clinicsSelect__3j_wZ"};